function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { fetchConversationResponseToConversation } from '@rocketlane/rocket-llm';
import { getAnalyticsSendMessagePayload, getFeedbackPayload } from 'api/ai-chat/utils';
import { HttpClient } from 'api/http-client';
import { CONVERSATION_SERVICE_URL } from 'config/environment';
import { getFileContentType } from 'utils/files';
export class AiAnalystsHttpClient extends HttpClient {
    async sendMessage(params) {
        const payload = getAnalyticsSendMessagePayload(params);
        const data = await this.post('/chat', payload);
        return data;
    }
    async getAllAnalyticsConversations(params) {
        const { offset, limit, agent_name } = params;
        if (agent_name == null || String(agent_name).trim() === '') {
            throw new Error('getAllAnalyticsConversations requires a non-empty agent_name to avoid mixing agents’ conversation histories');
        }
        const config = {
            params: {
                page: offset === 0 ? '1' : (offset / limit + 1).toString(),
                page_size: limit.toString(),
                agent_name: agent_name.trim()
            }
        };
        const data = await this.get('/chat/conversations', config);
        return data;
    }
    async getAnalyticsConversation(params) {
        try {
            const config = {
                params: {
                    conversation_id: params.conversation_id,
                    page: params.page,
                    page_size: params.page_size,
                    include_token: params.include_token
                }
            };
            const responseData = await this.get(`/chat/conversations/${params.conversation_id}`, config);
            return fetchConversationResponseToConversation(responseData);
        } catch (error) {
            var _error_response_data, _error_response;
            const errorMessage = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || (error === null || error === void 0 ? void 0 : error.message) || 'Error fetching conversation';
            throw new Error(errorMessage, {
                cause: error
            });
        }
    }
    async deleteAnalyticsConversation(conversationId) {
        await this.delete(`/chat/conversations/${conversationId}`);
    }
    // eslint-disable-next-line class-methods-use-this
    async getAnalysts() {
        try {
            const data = await this.get('/ai-analysts');
            return data;
        } catch (error) {
            var _error_response;
            const errorMessage = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.statusText) || (error === null || error === void 0 ? void 0 : error.message) || 'Failed to fetch analytics agents';
            throw new Error(errorMessage, {
                cause: error
            });
        }
    }
    async getSignalAgents() {
        const data = await this.get('/signal-agent');
        if (!data) {
            throw new Error('Failed to fetch signals agents');
        }
        return data;
    }
    async dispatchIntegrations(payload) {
        await this.post('/integrations/dispatch', payload);
    }
    async sendFeedback(params) {
        const payload = getFeedbackPayload(params);
        await this.post('/chat/feedback', payload);
    }
    async updateFeedback(params) {
        const payload = getFeedbackPayload(params);
        await this.put('/chat/feedback', payload);
    }
    async convertMarkdownToPdf(params) {
        const response = await this.post('/agent-exports/convert-markdown-to-pdf', params);
        return response.data;
    }
    async uploadFile(file) {
        const contentType = getFileContentType(file);
        const { upload_url, file_key } = await this.post(`${this.BASEURL}/agent-attachments/get_upload_url`, {
            file_name: file.name,
            content_type: contentType
        });
        const putHeaders = {};
        putHeaders['Content-Type'] = contentType;
        await this.put(upload_url, file, {
            headers: putHeaders
        });
        const { s3_url } = await this.post(`${this.BASEURL}/agent-attachments/confirm_upload?file_key=${encodeURIComponent(file_key)}`, undefined);
        return {
            s3_url,
            fileKey: file_key
        };
    }
}
_define_property(AiAnalystsHttpClient, "getStreamUrl", (streamId)=>{
    return `${CONVERSATION_SERVICE_URL}/api/v1/chat/stream/${streamId}`;
});
export const aiAnalystsHttpClient = new AiAnalystsHttpClient();
